var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"start","no-gutters":""}},_vm._l((_vm.count),function(i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"4","xl":"3","sm":"6"}},[_c('v-skeleton-loader',{staticClass:"ma-3",attrs:{"type":"card"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }